import { render, staticRenderFns } from "./fullScreenEditor.vue?vue&type=template&id=10b33884&scoped=true&"
import script from "./fullScreenEditor.vue?vue&type=script&lang=js&"
export * from "./fullScreenEditor.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenEditor.vue?vue&type=style&index=0&id=10b33884&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b33884",
  null
  
)

export default component.exports